/** @format */

import React, { useEffect, useState } from 'react';
import { Checkbox, makeStyles, Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import I18n from '../../components/Translate/I18n';
import adescomStyle from '../../assets/jss/adescom/adescomStyle';
import GridContainer from '../../components/Grid/GridContainer';
import GridItem from '../../components/Grid/GridItem';
import { useSelector } from 'react-redux';
import { rolesCredentialType } from '../../modules/platformGroups/reducers';

export const UserPermissionGroupSubElements = (props: {
    elements?: Array<any>;
    customRoles?: Array<any>;
    customGroups?: Array<any>;
    checkedElements: Array<string>;
    setCheckedElements: React.Dispatch<any>;
    isRootLogged: boolean;
}): React.ReactElement => {
    const useStyle = makeStyles(adescomStyle);
    const classes = useStyle();

    const tableStickyHeader = { root: classes.tableStickyHeader };
    const tableControlStickyHeader = { root: classes.tableControlStickyHeader };
    const tableCellRoot = { root: classes.tableCellRootBordered };
    const tableRowRoot = { root: classes.tableRowRoot };
    const [removedItems, setRemovedItems] = useState<Array<string>>([]);

    const { collections } = useSelector((state: { rolesCredentialReducers: rolesCredentialType }) => {
        return state.rolesCredentialReducers;
    });

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
        if (event.target.checked) {
            const newElements = [...props.checkedElements, event.target.name];
            props.setCheckedElements(newElements);
        } else {
            let newElements = props.checkedElements.filter((item: any) => {
                return item !== event.target.name;
            });
            props.setCheckedElements(newElements);
        }
    };

    const handleVisibleOnlyChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
        if (removedItems.length > 0) {
            let name: string | null = null;
            props.elements?.map((item: any) => {
                collections &&
                    collections['hydra:member'].map((el: any) => {
                        if (el.visibleOnly && el.parentGroup === event.target.name.split('_')[0]) {
                            name = el.permissionRoleName;
                        }
                    });
            });
            props.setCheckedElements([...props.checkedElements, ...removedItems]);
            setRemovedItems([]);
        } else {
            const itemToRemove: Array<string> = [];
            let name = null;
            props.elements?.map((item: any) => {
                collections &&
                    collections['hydra:member'].map((el: any) => {
                        if (item.menuName === el.parentGroup && (!el.rootOnly || props.isRootLogged) && !el.visibleOnly) {
                            itemToRemove.push(el.permissionRoleName);
                        }

                        if (el.visibleOnly && el.parentGroup === event.target.name.split('_')[0]) {
                            name = el.permissionRoleName;
                        }
                    });
            });
            let newElements = props.checkedElements.filter((item: any) => !itemToRemove.includes(item));
            setRemovedItems(itemToRemove);
            if (name) {
                props.setCheckedElements([...newElements, name]);
            } else {
                props.setCheckedElements(newElements);
            }
        }
    };

    const checkIsVisibleOnly = (collections: any, name: string): boolean => {
        let visible = false;

        if (collections && collections['hydra:member']) {
            collections['hydra:member'].map((el: any) => {
                if (el.visibleOnly && el.parentGroup === name) {
                    let n = el.permissionRoleName;
                    visible = props.checkedElements.includes(n);
                }
            });
        }

        return visible;
    };
    return (
        <Table>
            <TableHead>
                <TableRow>
                    <TableCell classes={tableControlStickyHeader} padding="none" align="right" style={{ width: 30 }}>
                        <I18n trans="permission_groups:t.name" />
                    </TableCell>
                    <TableCell classes={tableStickyHeader} padding="none" align="center" style={{ width: 30 }}>
                        <I18n trans="permission_groups:t.access" />
                    </TableCell>
                    <TableCell classes={tableStickyHeader} padding="none" align="center" style={{ width: 30 }}>
                        <I18n trans="permission_groups:t.visible_only" />
                    </TableCell>
                    <TableCell classes={tableStickyHeader} padding="none" align="center">
                        <I18n trans="permission_groups:t.custom_roles" />
                    </TableCell>
                    <TableCell classes={tableStickyHeader} padding="none" align="center" style={{ paddingLeft: 10 }}></TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {props.elements?.map((item: any) => {
                    let visibleForNotRoot = true;
                    if (props.isRootLogged) {
                        visibleForNotRoot = true;
                    } else {
                        collections &&
                            collections['hydra:member'].map((rolesCredential: any) => {
                                if (item.menuName === rolesCredential.permissionRoleName && rolesCredential.rootOnly) {
                                    visibleForNotRoot = false;
                                }
                            });
                    }
                    if (item.visible && visibleForNotRoot) {
                        return (
                            <TableRow classes={tableRowRoot} key={'key' + item.id}>
                                <TableCell classes={tableControlStickyHeader} style={{ width: 30 }} padding="none" align="left">
                                    <I18n trans={`general:menu.${item.menuName}`} />
                                </TableCell>
                                <TableCell classes={tableCellRoot} style={{ width: 30 }} padding="none" align="left">
                                    <Checkbox checked={props.checkedElements.includes(item.menuName)} onChange={handleChange} name={item.menuName} />
                                </TableCell>
                                <TableCell classes={tableCellRoot} style={{ width: 30 }} padding="none" align="left">
                                    <Checkbox
                                        checked={checkIsVisibleOnly(collections, item.menuName)}
                                        onChange={handleVisibleOnlyChange}
                                        name={`${item.menuName}_visible`}
                                    />
                                </TableCell>
                                <TableCell classes={tableCellRoot} padding="none" align="left">
                                    {collections &&
                                        collections['hydra:member'].map((el: any) => {
                                            if (item.menuName === el.parentGroup && (!el.rootOnly || props.isRootLogged) && !el.visibleOnly) {
                                                return (
                                                    <GridContainer justifyContent="center" alignItems="center">
                                                        <GridItem xs={10}>
                                                            <I18n trans={`general:menu.${el.permissionRoleName}`} />
                                                        </GridItem>
                                                        <GridItem xs={2}>
                                                            <Checkbox
                                                                disabled={checkIsVisibleOnly(collections, item.menuName)}
                                                                checked={props.checkedElements.includes(el.permissionRoleName)}
                                                                onChange={handleChange}
                                                                name={el.permissionRoleName}
                                                            />
                                                        </GridItem>
                                                    </GridContainer>
                                                );
                                            }
                                        })}
                                </TableCell>
                                <TableCell classes={tableCellRoot} style={{ paddingLeft: 10 }} padding="none" align="left"></TableCell>
                            </TableRow>
                        );
                    }
                })}
            </TableBody>
        </Table>
    );
};
